import { useState } from 'react'
import Icon from 'components/UIKit/Icon'
import { IconProps } from '~/ui/Icon'
import { Modal, MODAL_ANIMATION_VARIANT, ModalProps } from '~/ui/Modal'
import { Dialog } from '~/ui/Dialog'
import { Heading } from 'react-aria-components'
import { Button } from '~/ui/Button'

type Screen = {
  title: string
  component: React.FC<{ handleClose: () => void }>
  icon: IconProps['name']
}

type TemplatesModalProps = {
  title: string
  screens: Screen[]
} & ModalProps

const TemplatesModal = ({ screens, title, ...props }: TemplatesModalProps) => {
  const [selectedScreen, setSelectedScreen] = useState<Screen | null>(null)
  return (
    <Modal
      isDismissable
      {...props}
      onAnimationComplete={animation => {
        if (animation === MODAL_ANIMATION_VARIANT.hidden) setSelectedScreen(null)
      }}
    >
      <Dialog>
        {({ close }) => (
          <>
            <Heading slot="title" className="text-lg pb-3 mb-3 border-b">
              {!!selectedScreen && (
                <div
                  role="button"
                  className="w-[fit-content] text-sm underline hover:no-underline mb-2"
                  onClick={() => setSelectedScreen(null)}
                >
                  &larr; Back
                </div>
              )}
              <span>{title}</span>
            </Heading>
            {selectedScreen ? (
              <div className="relative">
                <selectedScreen.component handleClose={close} />
              </div>
            ) : (
              <div className="flex justify-around my-6">
                {screens.map((screen, i) => (
                  <Button
                    variant="secondary"
                    key={i}
                    className="flex flex-col px-20 py-6"
                    onClick={() => setSelectedScreen(screen)}
                  >
                    <Icon name={screen.icon} size="100" />
                    <span className="font-bold">{screen.title}</span>
                  </Button>
                ))}
              </div>
            )}
          </>
        )}
      </Dialog>
    </Modal>
  )
}

export default TemplatesModal
